import React, { useState } from "react";
import MultiRangeSlider from "./MultirangeSlider";

const FilterMobile = ({
  setshowFilter,
  formik,
  showFilter,
  fetchData,
  sethavFilter,
}) => {
  const [changed, setchanged] = useState(false);

  return (
    <>
      <div
        onClick={() => setshowFilter(false)}
        className={`${
          showFilter ? "block" : "hidden"
        } fixed top-0 left-0 h-full w-full bg-[#00000070] z-40`}
      ></div>
      <div
        className={`${
          showFilter ? "block" : "hidden"
        } fixed bottom-0 left-0 w-full bg-white p-5 rounded-t-[10px] z-50 text-[14px]`}
      >
        <span>
          <p className="text-[#2E3132] text-[14px] font-[500] mb-1">قیمت</p>
          <MultiRangeSlider
            min={0}
            max={20}
            type="price"
            changed={changed}
            text="year:"
            formik={formik}
            names={["min_price", "max_price"]}
            onChange={({ min, max }) => {
              formik.setFieldValue("min_price", min);
              formik.setFieldValue("max_price", max);
            }}
          />
        </span>
        <span>
          <p className="text-[#2E3132] text-[14px] font-[500] mb-1 mt-5">
            سال ساخت
          </p>
          <MultiRangeSlider
            min={1340}
            max={1403}
            type="year"
            changed={changed}
            text="year:"
            formik={formik}
            names={["year_start", "year_end"]}
            onChange={({ min, max }) => {
              formik.setFieldValue("year_start", min);
              formik.setFieldValue("year_end", max);
            }}
          />
        </span>
        <div className="">
          <p className="text-[#2E3132] text-[14px] font-[500] mb-1 mt-5">
            تناژ
          </p>
          <MultiRangeSlider
            min={0}
            max={10}
            type="tonaj"
            changed={changed}
            text="tonaj:"
            formik={formik}
            names={["min_tonaj", "max_tonaj"]}
            onChange={({ min, max }) => {
              formik.setFieldValue("min_tonaj", min);
              formik.setFieldValue("max_tonaj", max);
            }}
          />
        </div>
        <div className=" flex flex-col gap-2 mb-5">
          <p className="text-[#2E3132] text-[14px] font-[500] mb-1 mt-5">
          نوع جستجو{" "}
          </p>
          <span className="flex justify-between">
            <span className="text-[#2E3132] text-[12px] font-[400]">
              اسم محصول
            </span>
            <label class="inline-flex items-center cursor-pointer relative">
              <input
                type="radio"
                name="product"
                class="before:content[''] peer relative h-4 w-4 cursor-pointer appearance-none rounded-full border border-gray-600 text-gray-900 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-8 before:w-8 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-900 checked:before:bg-gray-900 hover:before:opacity-10"
                id="product"
                checked={formik.values.search_type === "product"}
                onClick={(e) => formik.setFieldValue("search_type", "product")}
              />
              <span class="absolute text-gray-900 transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-2.5 w-2.5"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                >
                  <circle data-name="ellipse" cx="8" cy="8" r="8"></circle>
                </svg>
              </span>
            </label>
          </span>
          <span className="flex justify-between">
            <span className="text-[#2E3132] text-[12px] font-[400]">
              شماره محصول
            </span>
            <label class="inline-flex items-center cursor-pointer relative">
              <input
                type="radio"
                name="product_number"
                id="product_number"
                class="before:content[''] peer relative h-4 w-4 cursor-pointer appearance-none rounded-full border border-gray-600 text-gray-900 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-8 before:w-8 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-900 checked:before:bg-gray-900 hover:before:opacity-40"
                checked={formik.values.search_type === "product_number"}
                onClick={(e) =>
                  formik.setFieldValue("search_type", "product_number")
                }
              />
              <span class="absolute text-gray-900 transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-2.5 w-2.5"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                >
                  <circle data-name="ellipse" cx="8" cy="8" r="8"></circle>
                </svg>
              </span>
            </label>
          </span>
        </div>
        <button
          onClick={() => {
            fetchData("filter");
            setshowFilter(false);
          }}
          className="btn-brand w-full "
        >
          اعمال
        </button>
      </div>
    </>
  );
};

export default FilterMobile;
